module.exports = __webpack_public_path__ + "static/media/external.24981daa.svg";